import OrgManagementContainer from "./OrgManagementContainer";

export default OrgManagementContainer;
